import LocalizedStrings from 'react-localization'
import { english } from './english'
import { portuguese } from './portuguese'
import { spanish } from './spanish'

const strings = new LocalizedStrings({
  pt: portuguese,
  en: english,
  es: spanish
})

// Set default language to English initially
// The language will be updated by the LanguageProvider
strings.setLanguage('en')

export default strings
